import {isEqual, isEmpty, head} from 'lodash'
import MISC from 'src/utils/helper/misc'

export default {
  routeToPromosDashboard() {
    return this.$router.replace({
      name: 'promos'
    })
  },
  setObjState (val, selectData) {
    selectData.state = val ? 'set' : 'unset'
  },
  setComponentVariable (cmpVariable, value) {
    this[cmpVariable] = value
  },
  removeFamily (familyId) {
    return this.$store.commit('promotions/updateTaggedFamilies', familyId)
  },
  getReleaseDate (familyArr) {
    if (!isEqual(familyArr.length, 0)) {
      const releaseDateArr = familyArr.map(({ releaseDate }) => ({
        releaseDate,
        diff: MISC.isValidValue(releaseDate) ? MISC.getDiffOfSecondsFromToday(releaseDate) : 0
      }))

      let newReleaseDateObj = {
        releaseDate: '',
        diff: 0
      }

      releaseDateArr.forEach((data) => {
        if (MISC.isValidValue(data.releaseDate) && MISC.isFutureDate(data.releaseDate)) {
          newReleaseDateObj = {
            releaseDate: (newReleaseDateObj.diff > data.diff) ? newReleaseDateObj.releaseDate : data.releaseDate,
            diff: (newReleaseDateObj.diff > data.diff) ? newReleaseDateObj.diff : data.diff
          }
        }
      })

      return newReleaseDateObj.releaseDate
    }

    return ''
  },
  
  isEveryTaggedFamiliesStyleSelected(taggedFamilies) {
    return taggedFamilies.findIndex(data => !(Array.isArray(data.checkedPacksArr) && data.checkedPacksArr.length > 0)) === -1;
  },
  
  isEmptyTaggedFamilyListNoAllFonts(selectFontDD, taggedFamilies) {
    return (isEqual(selectFontDD.allFonts, 'N') || isEqual(selectFontDD.allFonts, '')) && isEqual(taggedFamilies.length, 0);
  },
  
  isEmptyAllFamiliesList(allFamiliesList) {
    return isEqual(allFamiliesList.length, 0);
  },

  isErrorConditionMet(taggedFamilies, selectFontDD, allFamiliesList) {
    return !this.isEveryTaggedFamiliesStyleSelected(taggedFamilies) || 
           this.isEmptyTaggedFamilyListNoAllFonts(selectFontDD, taggedFamilies) || 
           this.isEmptyAllFamiliesList(allFamiliesList);
  },

  getCheckedPacksArr(taggedFamilies) {
    return taggedFamilies
      .map(family => family.checkedPacksArr || [])
      .reduce((accumulator, currentArray) => accumulator.concat(currentArray), []);
  },
  handlePromotionValidationSuccess(update, isError, context) {
    if (isError) return; // Ensure no error before proceeding
  
    // Prepare common promotion data
    const promoTitle = context.promoTitle;
    const startDate = context.getAPIDateFormat(context.startDate);
    const endDate = context.getAPIDateFormat(context.endDate);
    const promotionTypeId = context.promotionTypeID;
    const discount = context.discount;
    const secretCode = context.secretCode;
    const allFonts = context.selectFontDD.allFonts;
    const releaseDate = context.getReleaseDate(isEqual(allFonts, 'Y') ? context.allFamiliesList : context.taggedFamilies);
    const status = 'active';
    const selectedFoundry = context.getUserRoles(context.user) === 'foundrySupport'
      ? [] : context.foundriesList.find((data) => isEqual(data.id, context.foundry.id));
    const foundry = {
      id: context.getUserRoles(context.user) === 'foundrySupport' ? context.foundry.id : selectedFoundry.id,
      externalId: context.getUserRoles(context.user) === 'foundrySupport' ? context.foundry.externalId : selectedFoundry.externalId,
      name: context.getUserRoles(context.user) === 'foundrySupport' ? context.foundry.name : selectedFoundry.name
    };
  
    // Prepare promotionSKUs data
    const promotionSKUs = context.taggedFamilies.map((data) => ({
      familyName: data.familyName,
      familyId: Number(data.id),
      allStyle: data.isAllStyles,
      allPackages: data.isAllPacks,
      addSkus: data.checkedPacksArr.map((item) => ({
        skuId: item.skuId,
        skuName: item.description,
        skuType: item.packageType
      }))
    }));
  
    // Decide on action based on `update` flag
    if (update) {
      // For Edit Promotion
      const id = context.promotionId;
      const putObject = {
        promotionSKUs: isEqual(allFonts, 'Y') ? [] : promotionSKUs,
        promoTitle,
        foundry,
        promotionTypeId,
        releaseDate,
        sentStatus: 'in_progress', // This sent status will always be in_progress from FE for Add, Edit & Delete Promotions
        startDate,
        endDate,
        discount,
        secretCode,
        allFonts,
        status
      };
      const putPayload = { id, ...putObject };
      return context.$store.dispatch('promotions/updatePromotion', putPayload)
        .then((resp) => {
          context.$router.replace({ name: 'success_promotion' });
        })
        .catch((error) => {
        });
    } else {
      // For New Promotion
      const postObject = {
        promotionSKUs: isEqual(allFonts, 'Y') ? [] : promotionSKUs,
        promoTitle,
        foundry,
        promotionTypeId,
        releaseDate,
        sentStatus: 'in_progress',
        startDate,
        endDate,
        discount,
        secretCode,
        allFonts,
        status
      };
      return context.buildPostPromotionObject(postObject);
    }
  },
  
  handleValidationError(errors) {
    if (isEmpty(errors)) return false;
  
    const errorKeys = Object.keys(errors);
    const firstErrorKey = head(errorKeys);
    const firstErrorMessage = errors[firstErrorKey];
  
    if (MISC.isValidValue(firstErrorMessage)) {
      MISC.scrollIntoViewByFieldName(firstErrorKey);
      return true;
    }
  
    return false;
  },

  async checkPromotionLimit() {
    this.promotionLimitReached = false;
    const startDate = this.getAPIDateFormat(this.startDate);
    const promoYear = new Date(startDate).getFullYear();

    const filter = {
      scope: 'foundry',
      metricType: 'promotionCount',
      entityId: this.foundry.id,
      period: promoYear,
    };
    try {
      await this.$store.dispatch('metrics/fetchMetrics', filter);
      const promotionCount = this.$store.getters['metrics/getMetricByPeriod'](promoYear);

      if (promotionCount >= 50) {
        this.promotionLimitReached = true;
      }
    } catch (error) {
      console.error('Error checking promotion limit:', error);
    }
  },

  validatePromo (validate, bannedWordSecretCode, bannedWordPromoTitle, update = true , isUniqueSecretCode = false) {
    if (bannedWordSecretCode || bannedWordPromoTitle || this.promotionLimitReached) {
      return;
    }
    const isError = this.isErrorConditionMet(this.taggedFamilies, this.selectFontDD, this.allFamiliesList);
    const checkedPacksArr = this.getCheckedPacksArr(this.taggedFamilies);
  
    if (checkedPacksArr.length > 100 && isUniqueSecretCode) {
      return;
    }

      validate?.().then(({ valid, errors }) => {
      if (valid && !isError) {
        this.handlePromotionValidationSuccess(update, isError, this);
      } else {
        this.handleValidationError(errors);
      }
    });
  
    if (isError) {
      if (this.isEmptyAllFamiliesList(this.allFamiliesList)) {
        this.isNoFamiliesList = true;
      } else {
        this.isStyleNotSelectedError = true;
      }
    }
  }
}
